// We add event handler for #session-locale-choice form when
// it appears.
// We do this because we fetch footer html with this locale form from
// the Vue component LocalMapWithList.
document.addEventListener('change', (event) => {
  const select = event.target.closest('#session-locale-choice select')
  if (select) {
    const form = select.closest('form')
    if (form) {
      form.submit()
    }
  }
})
